
import { reactive, defineComponent } from "vue";
import { CodebookType, CodebookTypeTitle } from "./codebooks/CodebookType";

export default defineComponent({
  props: {
    type: String,
  },

  setup() {
    const codebooksType = CodebookType;

    const itemHeight = 3;

    const state = reactive({
      title: "title",
      height: CodebookTypeTitle.length * itemHeight + 3.5,
    });

    return {
      state,
      codebooksType,
      CodebookTypeTitle,
      itemHeight,
    };
  },
});
